// extracted by css-extract-rspack-plugin
export default {"root":"root-BcGVz4","panel":"panel-Gddkdt","chevron":"chevron-OIQmyB","item":"item-AUCaGl"};